// extracted by mini-css-extract-plugin
export default {"Form":"PredefinedSmsEdit_Form__V+QaS","FlexRow":"PredefinedSmsEdit_FlexRow__UTDGp","MessageTextareaContainer":"PredefinedSmsEdit_MessageTextareaContainer__6HUGF"};